import { registerPlugin } from '@capacitor/core';
const ActiveSubscriptionsCounter = registerPlugin('ActiveSubscriptionsCounter', {
    web: () => import('./web').then((m) => new m.ActiveSubscriptionsCounterWeb()),
});
export * from './definitions';
export { ActiveSubscriptionsCounter };
//# sourceMappingURL=index.js.map